import axios from "axios";

const getCityJson = async () => {
  let cityData = window.ChineseDistricts;
  
  if (cityData === undefined || cityData === null) {
    const url = `${location.protocol}//${location.host}/city.json`;
    const resp = await axios.get(url);
    cityData = resp.data;
    window.ChineseDistricts = cityData;
  }
  
  return cityData;
};

let cacheData = null;

async function getCityJsonData() {
  if (!cacheData) {
    cacheData = await getCityJson();
  }
  return cacheData;
}

const setData = (cityData, id) => {
  let data = [];
  for (let key in cityData[id]) {
    let item = cityData[id][key];
    for (let city in item) {
      data.push({
        key: parseInt(item[city].code),
        value: id == 3 ? `${item[city].address}-${item[city].zh}` : item[city].address
      });
    }
  }
  return data;
};

const getCityData = async id => {
  let data = [];
  if (id === -1) {
    return data;
  }
  if (id === null || id === "" || id === undefined || id === 0) {
    return [];
  }
  id = id || 1;
  
  // 大陆 + 港澳台
  const cityData = await getCityJsonData();

  if (id === 1) {
    data = setData(cityData, id);
  } else if (id == 2) {
    data = setData(cityData, id);
  } else if (id == 3) {
    data = setData(cityData, id);
  } else if (id == 120 || id == 12016) {
    let items = cityData[id];
    data = items
  } else {
    let items = cityData[id];
    for (var key1 in items) {
      data.push({
        key: parseInt(key1),
        value: items[key1]
      });
    }
  }
  return data;
};

export {getCityData,getCityJsonData};
